<!-- 
    Inline
    Renders content horizontally with consistent spacing between all items, spanning multiple lines if needed.

    Borrowed from Braid Design System
    https://seek-oss.github.io/braid-design-system/components/Inline

    <template>
        <div class="u-flex">
            <Children></Children>
        </div>
    </template>
-->

<script>
//TODO: eventually move this to a global import
import { isTagEmpty } from '@/util/render';
// import { validation } from '@/util/theme';


export default {
    props: {
        /**
        * Unique id for the element.
        */
        id: String,
        /**
        * Spacing between child elements.
        */
        spacing: {
            type: [String, Number],
            default: 2,
            // validator(value) {
            //     return validation.isValid('spacing', value);
            // },
        },
        /**
        * Child element(s) render tag.
        */
        element: {
            type: String,
            default: 'div',
        },
        /**
        * Removes 'flex-wrap' class from the rendered element
        */
        noWrap: Boolean,
        /**
        * Adds 'justify-center' class to the rendered element
        */
        center: Boolean,
        /**
        * Adds 'items-center' class to the rendered element
        */
        itemsCenter: Boolean
    },
    computed: {
        computedSpacing() {
            return parseInt(this.spacing);
        },
        containTop() {
            switch (this.computedSpacing) {
                case 1:
                    return '-mt-1';
                case 2:
                    return '-mt-2';
                case 3:
                    return '-mt-3';
                case 4:
                    return '-mt-4';
                case 5:
                    return '-mt-5';
                case 6:
                    return '-mt-6';
                case 8:
                    return '-mt-8';
                case 10:
                    return '-mt-10';
                default:
                    return '';
            }
        },
        containLeft() {
            switch (this.computedSpacing) {
                case 1:
                    return '-ml-1';
                case 2:
                    return '-ml-2';
                case 3:
                    return '-ml-3';
                case 4:
                    return '-ml-4';
                case 5:
                    return '-ml-5';
                case 6:
                    return '-ml-6';
                case 8:
                    return '-ml-8';
                case 10:
                    return '-ml-10';
                default:
                    return '';
            }
        },
        marginTop() {
            switch (this.computedSpacing) {
                case 1:
                    return 'mt-1';
                case 2:
                    return 'mt-2';
                case 3:
                    return 'mt-3';
                case 4:
                    return 'mt-4';
                case 5:
                    return 'mt-5';
                case 6:
                    return 'mt-6';
                case 8:
                    return 'mt-8';
                case 10:
                    return 'mt-10';
                default:
                    return '';
            }
        },
        marginLeft() {
            switch (this.computedSpacing) {
                case 1:
                    return 'ml-1';
                case 2:
                    return 'ml-2';
                case 3:
                    return 'ml-3';
                case 4:
                    return 'ml-4';
                case 5:
                    return 'ml-5';
                case 6:
                    return 'ml-6';
                case 8:
                    return 'ml-8';
                case 10:
                    return 'ml-10';
                default:
                    return '';
            }
        },
    },
    render(createElement) {
        return createElement(
            'div',
            {
                class: [
                    
                    'flex',
                    this.center ? 'justify-center': '',
                    this.noWrap ? '' : 'flex-wrap',
                    this.itemsCenter ? 'items-center' : '',
                    this.containTop,
                    this.containLeft
                ],
            },
            this.$slots.default.map((vNode) => {
                if (isTagEmpty(vNode)) {
                    return;
                }

                return createElement(
                    'div',
                    {
                        class: [this.marginTop, this.marginLeft]
                    },
                    [vNode]
                );
            })
        );
    },
};
</script>

